import { PageCode } from './codes';

export const pageList = {
	children: {
		dashboard: {
			locales: {
				cs: {
					slug: '',
				},
			},
			code: PageCode['dashboard'],
			children: {},
		},
		autorizace: {
			locales: {
				cs: {
					slug: 'autorizace',
				},
			},
			code: PageCode['autorizace'],
			children: {
				vysledek: {
					locales: {
						cs: {
							slug: 'vysledek',
						},
					},
					code: PageCode['autorizace'],
					children: {},
				},
			},
		},
		prihlaseni: {
			locales: {
				cs: {
					slug: 'prihlaseni',
				},
			},
			code: PageCode['prihlaseni'],
			children: {},
		},
		odhlaseni: {
			locales: {
				cs: {
					slug: 'odhlaseni',
				},
			},
			code: PageCode['odhlaseni'],
			children: {},
		},
		'reza-vyber': {
			locales: {
				cs: {
					slug: 'reza-vyber',
				},
			},
			code: PageCode['reza-vyber'],
			children: {},
		},
		sluzba: {
			locales: {
				cs: {
					slug: 'sluzba',
				},
			},
			code: PageCode['sluzba'],
			children: {},
		},
		nastaveni: {
			locales: {
				cs: {
					slug: 'nastaveni',
				},
			},
			code: PageCode['nastaveni'],
			children: {
				'kontaktni-udaje': {
					locales: {
						cs: {
							slug: 'kontaktni-udaje',
						},
					},
					code: PageCode['nastaveni-kontakt'],
					children: {},
				},
				'datove-schranky': {
					locales: {
						cs: {
							slug: 'datove-schranky',
						},
					},
					code: PageCode['datove-schranky-pripojeni'],
					children: {},
				},
			},
		},
		'ppdf-souhlasy': {
			locales: {
				cs: {
					slug: 'ppdf-souhlasy',
				},
			},
			code: PageCode['ppdf-souhlasy'],
			children: {},
		},
		epetice: {
			locales: {
				cs: {
					slug: 'e-petice',
				},
			},
			code: PageCode['epetice'],
			children: {
				zalozeni: {
					locales: {
						cs: {
							slug: 'zalozeni',
						},
					},
					code: PageCode['epetice-nova'],
					children: {},
				},
				detail: {
					locales: {
						cs: {
							slug: ':petitionId',
						},
					},
					code: PageCode['epetice-detail'],
					children: {
						editace: {
							locales: {
								cs: {
									slug: 'editace',
								},
							},
							code: PageCode['epetice-detail-editace'],
							children: {},
						},
					},
				},
			},
		},
		'moje-podani': {
			locales: {
				cs: {
					slug: 'moje-podani',
				},
			},
			code: PageCode['moje-podani'],
			children: {
				osvedceni: {
					locales: {
						cs: {
							slug: 'osvedceni',
						},
					},
					code: PageCode['moje-podani-osvedceni'],
					children: {},
				},
				autorizace: {
					locales: {
						cs: {
							slug: 'autorizace',
						},
					},
					code: PageCode['moje-podani-autorizace'],
					children: {
						detail: {
							locales: {
								cs: {
									slug: ':formularPodaniId',
								},
							},
							code: PageCode['moje-podani-autorizace'],
							children: {},
						},
					},
				},
				detail: {
					locales: {
						cs: {
							slug: ':submissionId',
						},
					},
					code: PageCode['moje-podani-detail'],
					children: {},
				},
			},
		},
		profil: {
			locales: {
				cs: {
					slug: 'profil',
				},
			},
			code: null,
			children: {
				doklady: {
					locales: {
						cs: {
							slug: 'doklady',
						},
					},
					code: PageCode['doklady'],
					children: {
						'obcansky-prukaz': {
							locales: {
								cs: {
									slug: 'obcansky-prukaz',
								},
							},
							code: PageCode['obcansky-prukaz'],
							children: {},
						},
						'cestovni-pas': {
							locales: {
								cs: {
									slug: 'cestovni-pas',
								},
							},
							code: PageCode['cestovni-pas'],
							children: {},
						},
						'ridicsky-prukaz': {
							locales: {
								cs: {
									slug: 'ridicsky-prukaz',
								},
							},
							code: PageCode['ridicsky-prukaz'],
							children: {},
						},
						'vlastni-doklad': {
							locales: {
								cs: {
									slug: 'vlastni-doklad/:documentId?',
								},
							},
							code: PageCode['vlastni-doklad'],
							children: {},
						},
					},
				},
				edoklady: {
					locales: {
						cs: {
							slug: 'edoklady',
						},
					},
					code: PageCode['profil-edoklady'],
					children: {},
				},
				rob: {
					locales: {
						cs: {
							slug: 'registr-obyvatel',
						},
					},
					code: PageCode['profil-ROB'],
					children: {},
				},
				ros: {
					locales: {
						cs: {
							slug: 'registr-osob',
						},
					},
					code: PageCode['profil-ROS'],
					children: {
						detail: {
							locales: {
								cs: {
									slug: ':ico/:agendaCode?',
								},
							},
							code: PageCode['profil-ROS'],
							children: {},
						},
					},
				},
				certifikaty: {
					locales: {
						cs: {
							slug: 'certifikaty',
						},
					},
					code: PageCode['profil-certifikaty'],
					children: {},
				},
				reza: {
					locales: {
						cs: {
							slug: 'reza',
						},
					},
					code: PageCode['profil-reza'],
					children: {},
				},
			},
		},
		'registr-ZP': {
			locales: {
				cs: {
					slug: 'registr-zivnostenskeho-podnikani',
				},
			},
			code: PageCode['registr-ZP'],
			children: {},
		},
		'muj-katastr-nemovitosti': {
			locales: {
				cs: {
					slug: 'muj-katastr-nemovitosti',
				},
			},
			code: PageCode['muj-katastr-nemovitosti'],
			children: {},
		},
		'registr-SV': {
			locales: {
				cs: {
					slug: 'registr-silnicnich-vozidel',
				},
			},
			code: PageCode['registr-SV'],
			children: {
				detail: {
					locales: {
						cs: {
							slug: ':vehicleId',
						},
					},
					code: PageCode['registr-SV-detail'],
					children: {},
				},
			},
		},
		podpora: {
			locales: {
				cs: {
					slug: 'podpora',
				},
			},
			code: PageCode['podpora'],
			children: {},
		},
		upozorneni: {
			locales: {
				cs: {
					slug: 'upozorneni',
				},
			},
			code: PageCode['upozorneni'],
			children: {},
		},
		'uzivatelska-prirucka': {
			locales: {
				cs: {
					slug: 'uzivatelska-prirucka',
				},
			},
			code: PageCode['uzivatelska-prirucka'],
			children: {},
		},
		drozd: {
			locales: {
				cs: {
					slug: 'drozd',
				},
			},
			code: PageCode['drozd'],
			children: {},
		},
		reza: {
			locales: {
				cs: {
					slug: 'reza',
				},
			},
			code: PageCode['reza'],
			children: {
				archive: {
					locales: {
						cs: {
							slug: 'archiv',
						},
					},
					code: PageCode['reza'],
					children: {},
				},
				templates: {
					locales: {
						cs: {
							slug: 'sablony',
						},
					},
					code: PageCode['reza'],
					children: {
						detail: {
							locales: {
								cs: {
									slug: ':id',
								},
							},
							code: PageCode['reza'],
							children: {},
						},
					},
				},
				detail: {
					locales: {
						cs: {
							slug: ':id',
						},
					},
					code: PageCode['reza'],
					children: {},
				},
			},
		},
		'datove-schranky': {
			locales: {
				cs: {
					slug: 'datove-schranky',
				},
			},
			code: PageCode['datove-schranky'],
			children: {
				schranka: {
					locales: {
						cs: {
							slug: 'schranka/:dataBoxId/:folderType',
						},
					},
					code: PageCode['datove-schranky-seznam'],
					children: {
						'nova-zprava': {
							locales: {
								cs: {
									slug: 'nova-zprava',
								},
							},
							code: PageCode['datove-schranky-nova'],
							children: {},
						},
						zprava: {
							locales: {
								cs: {
									slug: 'zprava/:messageId',
								},
							},
							code: PageCode['datove-schranky-zprava'],
							children: {
								odpoved: {
									locales: {
										cs: {
											slug: 'odpoved',
										},
									},
									code: PageCode['datove-schranky-odpoved'],
									children: {},
								},
								dalsi: {
									locales: {
										cs: {
											slug: 'dalsi',
										},
									},
									code: PageCode['datove-schranky-dalsi'],
									children: {},
								},
							},
						},
					},
				},
			},
		},
		'registr-ridicu': {
			locales: {
				cs: {
					slug: 'registr-ridicu',
				},
			},
			code: PageCode['registr-ridicu'],
			children: {},
		},
		'zdravotnicka-dokumentace': {
			locales: {
				cs: {
					slug: 'zdravotnicka-dokumentace',
				},
			},
			code: PageCode['zdravotnicka-dokumentace'],
			children: {},
		},
		'moje-soubory': {
			locales: {
				cs: {
					slug: 'moje-soubory',
				},
			},
			code: PageCode['moje-soubory'],
			children: {},
		},
		'sprava-souhlasu': {
			locales: {
				cs: {
					slug: 'sprava-souhlasu',
				},
			},
			code: PageCode['sprava-souhlasu'],
			children: {
				detail: {
					locales: {
						cs: {
							slug: ':consentId',
						},
					},
					code: PageCode['sprava-souhlasu-detail'],
					children: {},
				},
			},
		},
		'kde-o-mne-stat-vede-udaje': {
			locales: {
				cs: {
					slug: 'kde-o-mne-stat-vede-udaje',
				},
			},
			code: PageCode['kde-o-mne-stat-vede-udaje'],
			children: {},
		},
		sluzby: {
			locales: {
				cs: {
					slug: 'sluzby',
				},
			},
			code: PageCode['sluzby'],
			children: {
				oblibene: {
					locales: {
						cs: {
							slug: 'oblibene',
						},
					},
					code: PageCode['sluzby-oblibene'],
					children: {},
				},
			},
		},
		'casto-se-ptate': {
			locales: {
				cs: {
					slug: 'casto-se-ptate',
				},
			},
			code: PageCode['casto-se-ptate'],
			children: {},
		},
		'uzitecne-odkazy': {
			locales: {
				cs: {
					slug: 'uzitecne-odkazy',
				},
			},
			code: PageCode['uzitecne-odkazy'],
			children: {},
		},
		'vysledky-vyhledavani': {
			locales: {
				cs: {
					slug: 'vysledky-vyhledavani',
				},
			},
			code: PageCode['vysledky-vyhledavani'],
			children: {
				sluzby: {
					locales: {
						cs: {
							slug: 'sluzby',
						},
					},
					code: PageCode['vyhledavani-sluzby'],
					children: {},
				},
				'uzitecne-odkazy': {
					locales: {
						cs: {
							slug: 'uzitecne-odkazy',
						},
					},
					code: PageCode['vyhledavani-uzitecne-odkazy'],
					children: {},
				},
				'caste-dotazy': {
					locales: {
						cs: {
							slug: 'caste-dotazy',
						},
					},
					code: PageCode['vyhledavani-caste-dotazy'],
					children: {},
				},
			},
		},
	},
	locales: {
		cs: {
			slug: '',
		},
	},
	code: null,
};
